// extracted by mini-css-extract-plugin
export var button = "_k8-2";
export var card = "_k8-0";
export var closeButtonContainer = "_k8-3";
export var iconContainer = "_k8-1";